<template>
  <el-dialog :title="isUpdate ? '编辑 - 微信' : '添加 - 微信'" :visible="visible" width="960px" :destroy-on-close="true"
    :lock-scroll="false" custom-class="recolumn-qr-dialog" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="recolumn-qr-form">
      <el-row :gutter="24" class="recolumn-qr-layout">
        <el-col :sm="14">
          <el-form-item label="财务名称:" prop="finance_id">
            <el-select clearable filterable class="ele-block" v-model="form.finance_id" placeholder="请选择">
              <el-option v-for="item in financeList" :key="item.id" :value="item.id" :label="item.username" />
            </el-select>
          </el-form-item>
          <el-form-item label="微信昵称:" prop="account_name">
            <el-input clearable :maxlength="20" v-model.trim="form.account_name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="微信账号:" prop="account_number">
            <el-input clearable :maxlength="20" v-model.trim="form.account_number" placeholder="请输入" />
          </el-form-item>
          <el-form-item :label="isUpdate ? '实际余额:' : '初始余额:'" prop="sj_amount">
            <el-input clearable :maxlength="20" v-model.trim="form.sj_amount" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :sm="10" class="recolumn-qr-col">
          <el-form-item label="收款二维码:" prop="qr_image" class="recolumn-qr-item">
            <qr-code-upload v-model="form.qr_image" block @change="onQrUpload" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QrCodeUpload from '@/components/qrCodeUpload.vue';
import recolumnFormMixin from './recolumn-form-mixin';

export default {
  name: 'RecolumnEditWechat',
  components: { QrCodeUpload },
  mixins: [recolumnFormMixin],
  computed: {
    rules() {
      const rules = {
        finance_id: [{ required: true, message: '请选择', trigger: 'change' }],
        account_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        account_number: [{ required: true, message: '请输入', trigger: 'blur' }],
        sj_amount: [{ required: true, message: '请输入', trigger: 'blur' }],
      };
      if (!this.isUpdate) {
        rules.qr_image = [{ required: true, message: '请上传收款二维码', trigger: 'change' }];
      }
      return rules;
    },
  },
  methods: {
    handleSave() {
      this.save(this.buildPayload({ branch_name: '' }));
    },
  },
};
</script>

<style scoped>
.recolumn-qr-layout {
  align-items: stretch;
}

.recolumn-qr-col {
  display: flex;
  flex-direction: column;
}

.recolumn-qr-item {
  flex: 1;
  margin-bottom: 0;
  height: 100%;
}

.recolumn-qr-item ::v-deep .el-form-item__content {
  height: 420px;
  margin-left: 0 !important;
}

.recolumn-qr-item ::v-deep .el-form-item__label {
  float: none;
  display: block;
  text-align: left;
  line-height: 32px;
  padding: 0 0 8px;
}
</style>
